import { filterObjectValues } from 'helpers/filter'

import api from '../api'
import {
  GetAcquiredClientsListResponse,
  GetAcquiredClientsParams,
} from './types'

export const acquiredClientsApi = api.injectEndpoints({
  endpoints: build => ({
    getAcquiredClients: build.query<
      GetAcquiredClientsListResponse,
      GetAcquiredClientsParams
    >({
      query: params => ({
        url: `/web/acquired-clients/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    generateAcquiredClientsExcel: build.mutation<
      void,
      GetAcquiredClientsParams
    >({
      query: params => ({
        url: `/web/acquired-clients/export/`,
        params: filterObjectValues(params),
        cache: 'no-cache',
      }),
    }),
  }),
})
